import { FC } from "react";
import Content from "./Content";
import {Header ,SideNav} from "../../component/index";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';

import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

const Layout: FC = () => {
  const { orgLocations, selectedLocationId } = useSelector((state: RootState) => state.user);
  const activeLocation = (orgLocations ?? []).find(
    (loc: any) => String(loc.id) === String(selectedLocationId)
  ) || (orgLocations && orgLocations.length > 0 ? orgLocations[0] : null);

  const isLocationDeactivated = activeLocation && activeLocation.is_active === false;

  return (
    <div>
      <div className="dashboard">
        <Header/>
        <div className="d-flex">
          <SideNav/>
          <div className="main-wrapper">
            {isLocationDeactivated && (
              <div
                className="alert alert-warning d-flex align-items-center mb-4 shadow-sm"
                style={{
                  backgroundColor: "#fff8e6",
                  borderColor: "#ffe082",
                  color: "#855700",
                  borderRadius: "8px",
                  padding: "12px 18px",
                }}
              >
                <FontAwesomeIcon icon={faTriangleExclamation} className="me-2 fs-5 text-warning" />
                <div>
                  <strong>Location "{activeLocation?.display_name || activeLocation?.address || 'Current Location'}" is currently deactivated.</strong>
                  <br/>
                  <span>
                    New campaigns and journeys scheduling is blocked and active campaigns and journeys are paused for this location.
                  </span>
                </div>
              </div>
            )}
            <Content />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
